import { Badge, Button, fmt } from "@nabble/ui";
import type { AccountEmail } from "../../../../api/accountEmails";

interface OtherEmailItemProps {
  item: AccountEmail;
  resending: boolean;
  onMakePrimary: () => void;
  onResend: () => void;
  onRemove: () => void;
}

/** One secondary email: its status, and making it primary (confirmed) or resending its link (waiting). */
export function OtherEmailItem({ item, resending, onMakePrimary, onResend, onRemove }: OtherEmailItemProps): React.JSX.Element {
  return (
    <li className="nb-row-between">
      <div className="nb-cell-stack">
        <span className="nb-row">
          <strong>{item.email}</strong>
          {item.verified ? <Badge label="Confirmed" tone="success" /> : <Badge label="Waiting for confirmation" tone="warning" />}
        </span>
        <span className="nb-cell-sub">{`Added ${fmt.date(item.createdAt)}`}</span>
      </div>
      <div className="nb-row">
        {item.verified ? (
          <Button label="Make primary" variant="secondary" size="sm" icon="checkCircle" onClick={onMakePrimary} />
        ) : (
          <Button label="Resend link" variant="secondary" size="sm" icon="send" loading={resending} onClick={onResend} />
        )}
        <Button label="Remove" variant="danger-soft" size="sm" icon="trash" onClick={onRemove} />
      </div>
    </li>
  );
}
